export default function LinkButton({
  url = "#",
  variant = "primary",
  children,
  target = "_self",
}) {
  return (
    <a
      href={url}
      target={target}
      className={
        variant == "secondary"
          ? "px-8 py-2 rounded-xl flex items-center justify-center gap-2  border border-blue-600 text-white font-semibold hover:bg-blue-800 transition text-sm"
          : "px-8 py-2 rounded-xl flex items-center justify-center gap-2 bg-blue-600 text-white font-semibold hover:bg-blue-800 transition text-sm"
      }
    >
      {children}
    </a>
  );
}
